export default __webpack_public_path__ + "static/media/wave.046e8511.svg";